import { Component } from '@angular/core';
import { OriginalUserRoles, ReloadDashboard } from '../../../../core/auth/_actions/auth.actions';
import { Store } from '@ngrx/store';
import { AppState } from '../../../../core/reducers';
import { Router } from '@angular/router';

@Component({
  selector: 'kt-impersonation-indicator',
  templateUrl: './impersonation-indicator.component.html',
  styleUrls: ['./impersonation-indicator.component.scss'],
})
export class ImpersonationIndicatorComponent {
  constructor(private store: Store<AppState>, private router: Router) {}

  existImpersonationMode() {
    this.store.dispatch(new OriginalUserRoles());
    this.store.dispatch(new ReloadDashboard());
    this.router.navigate(['/dashboard'], {});
  }
}
